import { render, staticRenderFns } from "./CalificacionEditarForm.vue?vue&type=template&id=68195f90"
import script from "./CalificacionEditarForm.vue?vue&type=script&lang=js"
export * from "./CalificacionEditarForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports